import * as React from 'react';

import Localization from '../../config/localization';

import Colorbar from '../Colorbar';
import Contact from '../Contact';

import './Footer.scss';

class CustomFooter extends React.Component<Footer.IProps, Footer.IState> {
  state: Footer.IState = { contactModal: false };

  render() {
    return (
      <div className="footer">
        <Contact isOpen={this.state.contactModal} onClose={this._closeContactModal} />

        <div className="bottombar-topbar" />
        <div className="footer-container d-flex flex-nowrap h-100">
          <div className="links m-auto text-nowrap align-self-center">
            <a className="eon-darkgrey mr-2" href="https://www.eon.ro/termeni-si-conditii.html" target="_blank">
              {Localization.termsAndConditions}
            </a>
            <a className="eon-darkgrey mx-2" href="https://www.eon.ro/politica-de-utilizare-cookie-uri.html" target="_blank">
              {Localization.cookies}
            </a>
            <a className="eon-darkgrey mx-2" href="https://www.eon.ro/protectia-datelor.html" target="_blank">
              {Localization.dataProtection}
            </a>
            <a className="eon-darkgrey ml-2" href="" onClick={this._openContactModal}>
              {Localization.contact}
            </a>
            <p className="eon-darkgrey m-auto w-max-content">{Localization.contactMail}</p>
          </div>
          <div className="my-auto mr-5 pr-5 align-self-center">
            <div className="eon-logo small" />
          </div>
        </div>
        <Colorbar />
      </div>
    );
  }

  _closeContactModal = () => this.setState({ contactModal: false });

  _openContactModal = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    return this.setState({ contactModal: true });
  };
}

export default CustomFooter;
